import { useMemo } from 'react'

function getStrength(password: string): { level: 0 | 1 | 2 | 3; label: string } {
  if (!password) return { level: 0, label: '' }

  let score = 0
  if (password.length >= 6) score++
  if (password.length >= 10) score++
  if (/[A-Z]/.test(password) && /[a-z]/.test(password)) score++
  if (/\d/.test(password)) score++
  if (/[^A-Za-z0-9]/.test(password)) score++

  if (score <= 1) return { level: 1, label: 'Weak' }
  if (score <= 3) return { level: 2, label: 'Medium' }
  return { level: 3, label: 'Strong' }
}

const colors = {
  0: 'bg-neutral-200',
  1: 'bg-red-400',
  2: 'bg-yellow-400',
  3: 'bg-green-400',
}

const textColors = {
  0: 'text-neutral-400',
  1: 'text-red-500',
  2: 'text-yellow-600',
  3: 'text-green-600',
}

export function PasswordStrength({ password }: { password: string }) {
  const { level, label } = useMemo(() => getStrength(password), [password])

  return (
    <div className="mt-2">
      <div className="flex gap-1.5">
        {[1, 2, 3].map((segment) => (
          <div
            key={segment}
            className={`h-1.5 flex-1 rounded-full transition-all duration-300 ${
              segment <= level ? colors[level] : 'bg-neutral-200'
            }`}
          />
        ))}
      </div>
      {label && (
        <p className={`text-xs mt-1 transition-colors duration-300 ${textColors[level]}`}>
          {label}
        </p>
      )}
    </div>
  )
}
